import { cn } from '@/shared/lib'
import { Avatar } from '@/shared/ui/avatar'
import { type Employee, shortName } from '../model/schema'

interface EmployeeBadgeProps {
  employee: Employee
  /** Компактный вид — шапка колонки сетки: имя в одну строку, роль подписью. */
  compact?: boolean
  className?: string
}

export function EmployeeBadge({ employee, compact = false, className }: EmployeeBadgeProps) {
  return (
    <span className={cn('flex min-w-0 items-center gap-2', className)}>
      <Avatar name={employee.name} size="sm" />
      <span className="flex min-w-0 flex-col leading-tight">
        <span className="truncate text-sm text-text-primary">
          {compact ? shortName(employee) : employee.name}
        </span>
        {employee.role && (
          <span className="truncate text-[11px] text-text-tertiary">{employee.role}</span>
        )}
      </span>
    </span>
  )
}
